const _version = "3.7.0"
function version() {
    return _version
}
export default version
